import MenuItem from "@mui/material/MenuItem";
import Select, { type SelectChangeEvent } from "@mui/material/Select";
import CheckIcon from "@mui/icons-material/Check";

export type BitFlagOption = {
    value: number;
    label: string;
};

type BitFlagSelectProps = {
    labelId?: string;
    id?: string;
    label?: string;
    value: number;
    options: BitFlagOption[];
    onChange: (value: number) => void;
};

const flagsToArray = (flags: number, options: BitFlagOption[]) =>
    options
        .map(o => o.value)
        .filter(v => (flags & v) !== 0);

const arrayToFlags = (values: number[]) =>
    values.reduce((acc, v) => acc | v, 0);

export default function BitFlagSelect({
    labelId,
    id,
    label,
    value,
    options,
    onChange,
}: BitFlagSelectProps) {
    const selectedValues = flagsToArray(value, options);

    const handleChange = (e: SelectChangeEvent<number[]>) => {
        const values = e.target.value as number[];
        onChange(arrayToFlags(values));
    };

    return (
        <Select
            labelId={labelId}
            id={id}
            label={label}
            multiple
            value={selectedValues}
            onChange={handleChange}
            renderValue={(selected) =>
                (selected as number[])
                    .map(v => options.find(o => o.value === v)?.label ?? "")
                    .filter(Boolean)
                    .join(", ")
            }
        >
            {options.map(option => (
                <MenuItem key={option.value} value={option.value} sx={{ justifyContent: "space-between", gap: 2 }}>
                    {option.label}
                    {selectedValues.includes(option.value) && <CheckIcon fontSize="small" />}
                </MenuItem>
            ))}
        </Select>
    );
}